import { useDonation } from '../../context/DonationContext';
import { useNavigate } from 'react-router-dom';

export default function Oxxo() {
    const { donation } = useDonation();
    const navigate = useNavigate();

    const handleGenerateReference = () => {
        // Lógica para generar referencia OXXO
        navigate('/donar/confirmacion');
    };

    return (
        <div className="max-w-md mx-auto">
            <h2 className="text-2xl font-bold mb-6">Pago en OXXO</h2>

            <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <p>Monto a pagar: ${donation.amount} MXN</p>
            </div>

            <button
                onClick={handleGenerateReference}
                className="bg-yellow-600 text-white py-2 px-6 rounded hover:bg-yellow-700"
            >
                Generar referencia
            </button>

            <div className="mt-6 p-4 bg-blue-50 rounded-lg">
                <p className="font-bold">Instrucciones:</p>
                <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Haz clic en "Generar referencia"</li>
                    <li>Imprime o anota la referencia</li>
                    <li>Paga en cualquier tienda OXXO</li>
                </ol>
            </div>
        </div>
    );
}